export class PageFromHashGetter {
    public static get(hash: string): string | undefined {
        const pagePrefix = 'page=';
        const pageIndex = hash.indexOf(pagePrefix);

        if (pageIndex === -1) {
            return undefined;
        }

        const startIndex = pageIndex + pagePrefix.length;
        const valueStr = hash.substring(startIndex);

        const endIndex = valueStr.indexOf('&');
        const page = endIndex === -1 ? valueStr : valueStr.substring(0, endIndex);

        const trimmedPage = page.trim();
        return trimmedPage.length > 0 ? trimmedPage : undefined;
    };
}
